var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgElements(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 17,
    viewBox: "0 0 17 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16 14.9961C16 14.3057 15.4404 13.7461 14.75 13.7461C14.0596 13.7461 13.5 14.3057 13.5 14.9961C13.5 15.6864 14.0596 16.2461 14.75 16.2461C15.4404 16.2461 16 15.6864 16 14.9961Z",
    stroke: "#8300E9",
    strokeWidth: 1.25
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M9.75 14.9961C9.75 14.3057 9.19036 13.7461 8.5 13.7461C7.80964 13.7461 7.25 14.3057 7.25 14.9961C7.25 15.6864 7.80964 16.2461 8.5 16.2461C9.19036 16.2461 9.75 15.6864 9.75 14.9961Z",
    stroke: "#8300E9",
    strokeWidth: 1.25
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M3.5 14.9961C3.5 14.3057 2.94036 13.7461 2.25 13.7461C1.55964 13.7461 1 14.3057 1 14.9961C1 15.6864 1.55964 16.2461 2.25 16.2461C2.94036 16.2461 3.5 15.6864 3.5 14.9961Z",
    stroke: "#8300E9",
    strokeWidth: 1.25
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M16 8.74609C16 8.05574 15.4404 7.49609 14.75 7.49609C14.0596 7.49609 13.5 8.05574 13.5 8.74609C13.5 9.43645 14.0596 9.99609 14.75 9.99609C15.4404 9.99609 16 9.43645 16 8.74609Z",
    stroke: "#8300E9",
    strokeWidth: 1.25
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M16 2.49609C16 1.80574 15.4404 1.24609 14.75 1.24609C14.0596 1.24609 13.5 1.80574 13.5 2.49609C13.5 3.18645 14.0596 3.74609 14.75 3.74609C15.4404 3.74609 16 3.18645 16 2.49609Z",
    stroke: "#8300E9",
    strokeWidth: 1.25
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M9.75 8.74609C9.75 8.05574 9.19036 7.49609 8.5 7.49609C7.80964 7.49609 7.25 8.05574 7.25 8.74609C7.25 9.43645 7.80964 9.99609 8.5 9.99609C9.19036 9.99609 9.75 9.43645 9.75 8.74609Z",
    stroke: "#8300E9",
    strokeWidth: 1.25
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M9.75 2.49609C9.75 1.80574 9.19036 1.24609 8.5 1.24609C7.80964 1.24609 7.25 1.80574 7.25 2.49609C7.25 3.18645 7.80964 3.74609 8.5 3.74609C9.19036 3.74609 9.75 3.18645 9.75 2.49609Z",
    stroke: "#8300E9",
    strokeWidth: 1.25
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M3.5 8.74609C3.5 8.05574 2.94036 7.49609 2.25 7.49609C1.55964 7.49609 1 8.05574 1 8.74609C1 9.43645 1.55964 9.99609 2.25 9.99609C2.94036 9.99609 3.5 9.43645 3.5 8.74609Z",
    stroke: "#8300E9",
    strokeWidth: 1.25
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M3.5 2.49609C3.5 1.80574 2.94036 1.24609 2.25 1.24609C1.55964 1.24609 1 1.80574 1 2.49609C1 3.18645 1.55964 3.74609 2.25 3.74609C2.94036 3.74609 3.5 3.18645 3.5 2.49609Z",
    stroke: "#8300E9",
    strokeWidth: 1.25
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgElements);
export default __webpack_public_path__ + "static/media/elements.e3597a7e718c6d707136134e66a470f0.svg";
export { ForwardRef as ReactComponent };